import { useLocation, useNavigate } from "react-router-dom"
import { useStorage } from "./Storage"
import { useEffect } from "react"

const publicUrls = ['/signin', '/signup']

export function AuthGuard({ children }) {
    const [storage, , set] = useStorage()
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const validToken = storage.token && storage.token.exp > new Date().getTime() / 1000

    useEffect(() => {
        if (storage.token && !validToken) set('token')(null)
        if (validToken && publicUrls.some(x => pathname.includes(x))) navigate('/')
        if (!validToken && !publicUrls.some(x => pathname.includes(x))) navigate('/signin')
    }, [storage.token, pathname])

    if (!validToken && !publicUrls.some(x => pathname.includes(x))) return null

    return children
}